<template>
  <div class="form-list">
    <div v-for="cardType in cardTypes" :key="cardType.id" class="table-box form-large">
      <h3 class="table-title">{{ cardType.card_type_name }}薪资设置</h3>
      <el-table
        :data="cardType.salaries"
        class="income-table"
        border
        fit
        highlight-current-row
      >
        <el-table-column label="阶段" align="center">
          <template v-slot="{ $index, row }">
            第 {{ $index + 1 }} 阶段
          </template>
        </el-table-column>
        <el-table-column label="绩效" align="center">
          <template v-slot="{ row }">
            <div class="flex-align-center">
              <v-input-money :is-plain="true" v-model="row.salary"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template v-slot="{ $index, row }">
            <el-popover placement="top" v-model="row.showTip">
              <p>确认要删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="row.showTip = false">取消</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDelete($index, cardType.salaries)"
                >
                  确认
                </el-button>
              </div>
              <el-button class="edit-button" slot="reference" size="mini" type="danger">
                删除
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="add-button" type="success" @click="addSalaries(cardType)">新增一项</el-button>
    </div>

    <div class="submit-button-box">
      <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存设置</el-button>
    </div>
  </div>
</template>

<script>
  import RouteConfig from "@/router/config";
  import { getStoreCardTypes } from '@/api/store';
  import { updateTeacherSalaryStage } from '@/api/teacher';
  import { toCent, toYuan } from '@/filters';

  export default {
    name: RouteConfig.teacherStageSalaryEdit.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      cardTypes: [],
    }),
    beforeMount() {
      this.getCardTypes();
    },
    methods: {
      addSalaries({ id, salaries }) {
        salaries.push({
          card_type_id: id,
          salary: 0,
        });
      },
      handleDelete(index, rows) {
        rows.splice(index, 1);
      },
      async getCardTypes() {
        const { isError, data } = await getStoreCardTypes();
        if (isError) return;

        data.forEach(item => {
          item.salaries.forEach(salaryItem => salaryItem.salary = toYuan(salaryItem.salary));
        });

        this.cardTypes = data;
      },
      async handleSubmit() {
        if (this.isSaving) return;

        this.isSaving = true;

        const teacher_salary_stages = [];
        this.cardTypes.forEach(cardType => {
          cardType.salaries.forEach(item => {
            teacher_salary_stages.push({
              card_type_id: cardType.id,
              salary: toCent(item.salary),
            });
          });
        });

        const { isError } = await updateTeacherSalaryStage({ teacher_salary_stages });
        this.isSaving = false;
        if (!isError) this.$message.success('已成功保存薪资设置！');
      },
    },
  };
</script>

<style src="./SalaryStage.css" scoped/>
